module.exports = {"520403001":"安平街道","520403002":"鼓楼街道","520403101":"白云镇","520403102":"高峰镇","520403103":"天龙镇","520403104":"夏云镇","520403105":"马场镇","520403106":"乐平镇","520403107":"齐伯镇","520403202":"十字回族苗族乡","520403203":"羊昌布依族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520403.json
// module id = 2291
// module chunks = 0